import { Typography } from '@mui/material'
import { Section } from '../section'
import { icons } from '../../../../../../utils/icons'
import { useTranslation } from 'react-i18next'
import { useStyles } from './styles'

export type InstructionsSectionProps = {
  instructions?: string
}

function InstructionsSection({ instructions }: InstructionsSectionProps) {
  const { t } = useTranslation()
  const styles = useStyles()

  if (!instructions) return null

  return (
    <Section icon={icons('info-outlined')} title={t('actionPlan.sections.instructions')}>
      <Typography sx={styles.text}>{instructions}</Typography>
    </Section>
  )
}

export { InstructionsSection }
